import React, { useEffect, useState } from 'react';

const Confetti = ({ trigger, duration = 3000 }) => {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    if (trigger) {
      const colors = ['#C4622D', '#7A9E7E', '#1C1209', '#EBE5D9'];
      const newPieces = Array.from({ length: 50 }).map((_, i) => ({
        id: i,
        left: `${Math.random() * 100}vw`,
        animationDelay: `${Math.random() * 0.5}s`,
        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
        width: `${Math.random() * 6 + 6}px`,
        height: `${Math.random() * 10 + 10}px`,
      }));
      setPieces(newPieces);

      const timer = setTimeout(() => {
        setPieces([]);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [trigger, duration]);

  if (!trigger) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {pieces.map((piece) => (
        <div
          key={piece.id}
          className="confetti-piece rounded-sm"
          style={{
            left: piece.left,
            animationDelay: piece.animationDelay,
            backgroundColor: piece.backgroundColor,
            width: piece.width,
            height: piece.height,
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;